import {useTitle} from 'hooks';
import {useParams} from 'react-router-dom';

import TeamMine from './component/Team.Mine';

interface IPageTeamProps {}

const PageTeam = ({}: IPageTeamProps) => {
  useTitle('Team');

  const params = useParams();
  const workspace = params.workspace;

  if (workspace === 'me') {
    return <TeamMine />;
  }

  return null;
};

export default PageTeam;
